import { Middlewares } from "@/app/shared/services/app-router/middlewares";
import Guard from "vue-router-multiguard";

export default [
    {
        path: "/settings",
        name: "AdminSettings",
        component: () => import("./views/settingsList"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/settings/create",
        name: "CreateSettings",
        component: () => import("./views/updateSettings"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/settings/update/:id",
        name: "UpdateSettings",
        component: () => import("./views/updateSettings"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
];
